var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortofolioFirstPhotoTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 313,
    viewBox: "0 0 703 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0288 277.696C-7.47121 223.962 -28.7712 164.391 43.6128 89.7189C115.997 15.0469 273.766 -11.4151 368.059 5.97194C462.352 23.3589 580.724 49.9839 651.613 115.001C722.502 180.018 715.113 218.629 651.613 266.043C588.113 313.457 540.248 301.743 397.602 304.657C328.282 306.073 272.47 312.435 223.255 312.435C171.198 312.436 126.52 305.318 81.0288 277.696Z",
    fill: "#EDA751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortofolioFirstPhotoTablet);
export default __webpack_public_path__ + "static/media/PortofolioFirstPhotoTablet.e0264b8a2c45787b1bbddbad7c046848.svg";
export { ForwardRef as ReactComponent };